import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import fetchCalendlyLinks from './useCalendlyLinks.request';
import { SpecialistCalendlyLink } from './useCalendlyLinks.interface';

export default function useCalendlyLinks<T = SpecialistCalendlyLink[]>(
    options?: UseQueryOptions<SpecialistCalendlyLink[], unknown, T>
) {
    return useQuery<SpecialistCalendlyLink[], unknown, T>({
        queryKey: ['CalendlyLinks'],
        queryFn: fetchCalendlyLinks,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        ...options,
    });
}
